import styled from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Link } from 'foundations-components/transitional/components/Link';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { getPublicLang } from 'academy-common-lib/utils/url';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../../../utils/usageTracker';
import { appendHubsContent } from '../../../../utils/urls';
import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const publicLang = getPublicLang();
const LinkHovered = styled.div.withConfig({
  displayName: "NavGroupLink__LinkHovered",
  componentId: "f4eytk-0"
})(({
  theme
}) => ({
  '&:hover': {
    color: theme.color['text-interactive-on-fill-hover']
  }
}));
const NavGroupLink = ({
  link
}) => {
  const {
    isNotTablet
  } = useMediaQuery('laptop');
  const href = link.hrefs[publicLang] || link.hrefs.en;
  if (!href) return null;
  const shouldDisplayEnglishLanguageTag = publicLang !== 'en' && href === link.hrefs.en;
  return /*#__PURE__*/_jsx("li", {
    children: /*#__PURE__*/_jsx(View, {
      borderBlockStartColor: !isNotTablet ? 'do-not-use-transparent' : 'do-not-use-heffalump',
      borderBlockStartStyle: !isNotTablet ? 'solid' : 'none',
      borderBlockStartWidth: !isNotTablet ? '100' : '0',
      display: "block",
      children: /*#__PURE__*/_jsx(Link, {
        href: appendHubsContent(href, I18n.text(link.i18nKey)),
        onClick: () => usageTracker.track('navInteraction', {
          action: 'footer-link-click',
          href
        }),
        use: "unstyled",
        children: /*#__PURE__*/_jsx(Paragraph, {
          color: "do-not-use-battleship",
          margin: "0",
          paddingBlock: isNotTablet ? '200' : '400',
          paddingInline: isNotTablet ? '0' : '400',
          textAlign: !isNotTablet ? 'center' : 'left',
          typography: "heading-50",
          children: /*#__PURE__*/_jsxs(LinkHovered, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: link.i18nKey
            }), shouldDisplayEnglishLanguageTag && /*#__PURE__*/_jsx(Badge, {
              display: "inline-block",
              marginInlineStart: "200",
              use: "candy-apple",
              children: publicLang === 'ja' ? '英' : 'EN'
            })]
          })
        })
      })
    })
  }, link.i18nKey);
};
export default NavGroupLink;